import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// Workspace token layer (brand CSS custom properties + font-faces only — no
// element rules, so existing screens are unaffected until they use the tokens).
import "./workspace/tokens.css";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { loadConfig } from "./config";

const queryClient = new QueryClient();

(async () => {
  try {
    await loadConfig();
    const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
    root.render(
      <React.StrictMode>
        <DndProvider backend={HTML5Backend}>
          <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} />
          </QueryClientProvider>
        </DndProvider>
      </React.StrictMode>,
    );

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();
  } catch (e) {
    console.error("App failed to start due to config error", e);
  }
})();
